import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userProfiles: {},
    loading: false,
    error: null
};

const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setUserProfiles: (state, action) => {
            state.userProfiles = action.payload;
        },
        updateUserProfile: (state, action) => {
            const { username, data } = action.payload;
            state.userProfiles[username] = {
                ...state.userProfiles[username],
                ...data
            };
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        }
    }
});

export const { 
    setUserProfiles, 
    updateUserProfile, 
    setLoading, 
    setError 
} = usersSlice.actions;

export default usersSlice.reducer; 